import { createContext, ReactNode, useCallback, useContext, useState } from 'react';
import DomainInfoModal from './DomainInfoModal';

interface DomainModalContextValue {
  open: (domain: string) => void;
  close: () => void;
}

const DomainModalContext = createContext<DomainModalContextValue | null>(null);

export function DomainModalProvider({ children }: { children: ReactNode }) {
  const [domain, setDomain] = useState<string | null>(null);

  const open = useCallback((d: string) => setDomain(d), []);
  const close = useCallback(() => setDomain(null), []);

  return (
    <DomainModalContext.Provider value={{ open, close }}>
      {children}
      {domain && <DomainInfoModal domain={domain} onClose={close} />}
    </DomainModalContext.Provider>
  );
}

/** Returns helpers to open/close the global domain info modal. Safe to call from anywhere. */
export function useDomainModal(): DomainModalContextValue {
  const ctx = useContext(DomainModalContext);
  if (!ctx) {
    // Soft fallback so components used outside the provider (e.g. tests) don't crash.
    return { open: () => {}, close: () => {} };
  }
  return ctx;
}
